module.exports = __webpack_public_path__ + "static/media/ELS43M67.9ca48182.png";